import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { CaseFormModel } from './case-form.model';
import { IEscalateCase } from 'app/shared/models/escalate-case.model';
import { ICaseClosureSurvey } from 'app/shared/models/case-closure-survey.model';
import { CaseTypeEnum } from 'app/shared/enums/case-type.enum';

@Injectable({
  providedIn: 'root'
})
export class CaseFormService {

  selectedSerialForm!: any;
  onChangeCaseStageEmiter: EventEmitter<any> = new EventEmitter();  
  onChangeProductSuiteAndCompanyEmitter: EventEmitter<any> = new EventEmitter();  
  caseEscalated$= new Subject<IEscalateCase>();

  constructor(private http: HttpClient) { }

  saveCase(params: CaseFormModel): Observable<any> {
    let url = this.http.post('/v1/case-management', params);
    if(params.id) {
      url = this.http.put(`/v1/case-management?id=${params.id}`, params);
    }

    return url;
  }

  getCase(id: number): Observable<any> {
    return this.http.get(`/v1/case-management?id=${id}`);
  }

  getCaseDataBySerialNumber(serialNumber: string) {
    return this.http.get(`/v1/case-management/manually?serialNumber=${serialNumber}`);
  }

  getCaseComments(caseType: string, caseId: number, parentId?: number | null, type?: string): Observable<any> {
    let params: any = caseType === CaseTypeEnum.CASE
      ? { caseId }
      : { problemRecordId: caseId };

    if (parentId) {
      params = { ...params, parentId };
    }

    if (caseType === CaseTypeEnum.CASE && type) {
      params = { ...params, type };
    }
    return this.http.get(`/v1/${caseType === CaseTypeEnum.CASE ? 'case-comment' : 'problem-record-comment'}`, { params });
  }

  saveCaseComments(caseType: string, params: any): Observable<any> {
    const payload: any = {
    ...(caseType === CaseTypeEnum.CASE
      ? { caseId: params.caseId || params.id }
      : { problemRecordId: params.problemRecordId || params.caseId || params.id }),
    parentId: params.parentId ?? null,
    content: params.content ?? params.comment
    };
    return this.http.post(`/v1/${caseType === CaseTypeEnum.CASE ? 'case-comment' : 'problem-record-comment'}`, payload);
  }

  saveTicketClosure(caseId: number, params: any): Observable<any> {
    return this.http.post(`/v1/case-management/close?id=${caseId}`, params);
  }

  escalateCase(form: IEscalateCase) {
    return this.http.post(`/v1/case-management/escalate?id=${form.caseId}`, form);
  }

  deEscalateCase(form: IEscalateCase) {
    return this.http.post(`/v1/case-management/deescalate?id=${form.caseId}`, form);
  }

  saveCaseLinks(caseId: number, params: any): Observable<any> {
    return this.http.put(`/v1/case-links?caseId=${caseId}`, params);
  }

  submitClosureSurvey(caseId: number, body: ICaseClosureSurvey) {
    return this.http.post(`/v1/case-management/survey?id=${caseId}`, body);
  }

}
